/**
 * Shared client-side constants. Server contracts that the browser surfaces
 * (extension + web) must agree with live here so a future server bump only
 * needs one edit.
 */

/**
 * Server enforces a 100-char max on `PATCH /v1/devices/:id` (see the `name.length > 100`
 * guard in `apps/server/src/routes/devices.ts`). Extension and web cap user input at
 * this length so a longer rename hits a disabled Save button instead of a generic API
 * error. Keep this value in sync with the server's check if it ever changes.
 */
export const MAX_DEVICE_NAME_LENGTH = 100;

/**
 * Visibility window for the post-pair confirm card (7 days, in milliseconds). Both browser
 * surfaces (extension popup, web PWA) hide the card once `Date.now() - createdAt` exceeds
 * this. Consolidated here so a future tweak (e.g. shortening to 3 days) is a single edit.
 */
export const PAIR_CONFIRM_WINDOW_MS = 7 * 24 * 60 * 60 * 1000;
